import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { WorkerRate } from "../_types/worker-rate";

@Injectable({
    providedIn: 'root',
})
export class WorkerRatesService extends Service<WorkerRate> {
  public override type = 'workerRates';
  public override url = 'providers/workerRates';
}
